export const initialState = {
    loading:false,
    vehicleModels:[],
    vehicleSubModels:[],
    subModelLoading: false,
    lists:'',
    policies:[]
};
